import { render, staticRenderFns } from "./CookiesPolicyModal.vue?vue&type=template&id=0a1f6ab2"
import script from "./CookiesPolicyModal.vue?vue&type=script&lang=js"
export * from "./CookiesPolicyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports